import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { CompanyService } from '@services/my-insurance/company.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule],
  selector: 'app-dashboard-nav',
  templateUrl: './dashboard-nav.component.html',
})
export class DashboardNavComponent implements OnInit {
  @Input() policyId: string;
  @Input() policyType: string;
  isAcmic = false;
  showCompany: string;

  constructor(private acmicService: AcmicService,
    private companyService: CompanyService) {}

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.companyService.$currentCompany.subscribe((company)=>{
      this.showCompany = company;
    });
  }
}
